import { ComponentIds } from '@inter-ikea-core/core';
import { PlannerEcsSystem, ProductType } from '@inter-ikea-storageone/range';
import { COMPONENT_IDS } from '@inter-ikea-storagetwo/range';
import { addInvisibleEntity, removeInvisibleEntity } from '../functions/addInvisibleEntity';
const ADJUSTABLE_EXTS = [ProductType.BOAXEL_ADJ_SHELF_EXT, ProductType.BOAXEL_ADJ_CLOTHES_RAIL_EXT];
/**
 * System that adds invisible entities to the scene for adjustable products
 * made from MSC products in DEXF, since they lack proper product data.
 */
export class AddInvisibleAdjustableEntitySystem extends PlannerEcsSystem {
    constructor(boaxelCoreApi) {
        super(boaxelCoreApi, 'AddInvisibleAdjustableEntitySystem', ComponentIds.GUEST_CONNECTIONS_COMPONENT_ID);
        this.mandatoryComponents = [COMPONENT_IDS.ADJUSTABLE_COMPONENT];
        this.products = [];
    }
    setMarketProducts(marketProducts) {
        this.products = marketProducts;
    }
    onAdd(entity) {
        addInvisibleEntity(entity, this.products, ADJUSTABLE_EXTS, this.coreApi);
    }
    onUpdate() {
        return;
    }
    onRemove(entity) {
        removeInvisibleEntity(entity, this.coreApi);
    }
}
//# sourceMappingURL=AddInvisibleAdjustableEntitySystem.js.map